import { IProjectState } from 'store/types/project'
import { IProject } from 'types/project'

export const getInitialState = (): IProjectState => ({
  data: {} as IProject,
  isNewProject: false,
  isLoading: false,
  isRendering: false,
  metaData: null,
  projectThumbnailPath: null
})
